import { EvaluationMark } from '@modules/EvaluationModule/enums/EvaluationMark';

export const markValues = [
  { title: 'Needs development', value: EvaluationMark.NeedsDevelopment },
  { title: 'Successful', value: EvaluationMark.Successful },
  { title: 'Exceeds', value: EvaluationMark.Exceeds },
];
